"use client"

import { Bird } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BirdIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BirdIcon = component(Icon)({ as: Bird })
